import { ScanStatusDto, FoundDevicesDto } from '../dto/device-detector.dto'
import { ScanStatusModel, FoundDevicesModel, ScanStatusModelStatus } from '../../models/device-detector.model'

const toSerialNumber = (device: { serialNumber?: string; humanReadableId?: string; uniqueId?: string }): string | null => {
  const candidates = [device.humanReadableId, device.serialNumber, device.uniqueId]

  for (const candidate of candidates) {
    if (typeof candidate !== 'string') continue

    const trimmedValue = candidate.trim()
    if (trimmedValue.length > 0) {
      return trimmedValue
    }
  }

  return null
}

const toDeviceType = (device: { type?: string }): string | undefined => {
  if (typeof device.type !== 'string') return undefined
  const trimmedType = device.type.trim()
  return trimmedType.length > 0 ? trimmedType : undefined
}

const toIpAddress = (device: { communicationInterfaceAddress?: string }): string | undefined => {
  if (typeof device.communicationInterfaceAddress !== 'string') return undefined
  const trimmedAddress = device.communicationInterfaceAddress.trim()
  return trimmedAddress.length > 0 ? trimmedAddress : undefined
}

export const scanStatusDtoToModelTransformer = (dto: ScanStatusDto): ScanStatusModel => ({
  status: dto.status as ScanStatusModelStatus | undefined,
  scanStatus: dto.scanStatus,
  startedAt: dto.startedAt,
  completedAt: dto.completedAt,
  devices: (dto.devices ?? [])
    .map(device => {
      const serialNumber = toSerialNumber(device)
      if (serialNumber === null) return null

      return {
        serialNumber,
        type: toDeviceType(device),
        ipAddress: toIpAddress(device),
      }
    })
    .filter(device => device !== null),
})

export const foundDevicesDtoToModelTransformer = (dto: FoundDevicesDto): FoundDevicesModel => {
  const devices = dto.foundDevices ?? []

  return {
    devices: devices
      .map(device => {
        const serialNumber = toSerialNumber(device)
        if (serialNumber === null) return null

        return {
          index: device.index,
          serialNumber,
          type: toDeviceType(device),
          ipAddress: toIpAddress(device),
        }
      })
      .filter(device => device !== null),
  }
}
